<aside
  class="course-navigation-panel"
  [class.collapsed]="collapsed()"
>
  <button
    type="button"
    class="panel-header"
    [attr.aria-label]="(collapsed()
      ? 'h5pPlayer.courseNavigation.expand'
      : 'h5pPlayer.courseNavigation.collapse') | translate"
    [attr.aria-expanded]="!collapsed()"
    [attr.aria-controls]="panelBodyId"
    (click)="toggle()"
  >
    <mat-icon class="toggle-icon size-m">menu_open</mat-icon>
    @if (!collapsed()) {
      <h2 class="panel-title">
        {{ 'h5pPlayer.courseNavigation.title' | translate }}
      </h2>
    }
  </button>

  <div [id]="panelBodyId" class="panel-body"></div>
</aside>
